export const consentInline = () => {
  const consentsElement = document.querySelector("[data-wm-consent-inline]");
  const consentsPrivacyStatementElement = document.querySelector(
    "[data-wm-consent-inline-privacy-statement]"
  );

  if (!consentsElement || !consentsPrivacyStatementElement) {
    return;
  }

  const consentActionInput = document.querySelector(
    "[data-wm-consent-hidden-consent-action]"
  );
  const optInInput = document.querySelector("[data-wm-consent-hidden-optin]");
  const radioButtonOptionYes = document.querySelector(
    "[data-wm-consent-inline-radio][value='y']"
  );
  const radioButtonOptionNo = document.querySelector(
    "[data-wm-consent-inline-radio][value='n']"
  );
  const consentInlineRequiredHidden = document.querySelector(
    "[data-wm-consent-inline-required-hidden]"
  );

  const countrySelect = document.querySelector("select#id_country");

  let lastChosenCountryWasGermanic = false;

  const shouldWeOfferSubscription = () => {
    // AK doesn't recognize the user
    // Reasons:
    // 1- No AKID
    // 2- Has AKID but already sign it, so we assume is sharing the url
    // This prop comes from ajax context call made by AK
    // Actions must have been set to "Recognize users: Once!!!"
    // RESULT:  We show consents
    if (!actionkit.context?.recognized_user) {
      return true;
    }

    // AKID is present so we know the user
    // AK recognizes the user and is germanic
    // Also in this case we show only the #known_user (You already signed as...)
    // So there's no form, so no way to change the country :(
    // RESULT: We hide consents
    const userCountry = document.querySelector("[data-wm-user-country]");

    if (
      userCountry &&
      (userCountry.value === "austria" ||
        userCountry.value === "at" ||
        userCountry.value === "germany" ||
        userCountry.value === "de")
    ) {
      return false;
    }

    // Daisy chain scenario
    // Reasons:
    // - Has AKID and have just signed the previous action but not this one
    // - Is not germanic doh!
    // - And we already show the consents in the previous action so we don't show it again
    // RESULT: We hide consents
    const queryString = new URLSearchParams(window.location.search);
    const consentParameter = queryString.get("consent");

    if (consentParameter) {
      return false;
    }

    // User has already given to us the consents choice (either yes or no [sub/unsub in AK])
    // AK users might have three values as "user.subscription_status" (server side in django templates)
    // never, subscribed or unsubscribed
    // If never we can show consents, but if already has chosen we hide consents
    // This can happen when:
    // - Fist AK recognizes the user
    // - Secondly is not coming from a daisy chain (important!)
    // - Is not germanic doh!
    // - Lastly subscription_status is never exclusively
    // RESULT: We show consents together with #known_user div
    const userSubscriptionStatus = document.querySelector(
      "[data-wm-user-subscription-status]"
    );

    if (userSubscriptionStatus && userSubscriptionStatus.value !== "never") {
      return false;
    }

    // User took another action so it is recognized
    // doesn't come from daiys chain
    // is not germanic
    // never opted in nor out (never case)
    // So we show it
    return true;
  };

  const setupKnownUserDOM = () => {
    consentsElement.hidden = true;
    // This hidden input overrides the default AK behavior
    // that subcribes just because the user sign it. (US scenario)
    // So we avoid this always that we don't present consents!
    consentsElement.innerHTML = `<input type="hidden" name="opt_in" value="1" />`;
    consentsPrivacyStatementElement.remove();
  };

  const shouldTriggerValidation = () => {
    return (
      consentsElement.querySelectorAll(
        "[data-wm-consent-inline-radio].ak-error"
      ).length > 0
    );
  };

  const getCountryValue = () => {
    if (!countrySelect) {
      return "";
    }

    return countrySelect.value.toLowerCase();
  };

  const getIsGermanicCountry = () => {
    const selectedCountry = getCountryValue();

    if (selectedCountry === "") {
      return window.wemove.page.language.iso === "de";
    } else {
      return selectedCountry === "austria" || selectedCountry === "germany";
    }
  };

  const setConsentStatusByCountry = () => {
    const isGermanicCountry = getIsGermanicCountry();

    if (isGermanicCountry) {
      lastChosenCountryWasGermanic = true;
      optInInput.value = "1";
      consentInlineRequiredHidden.name = "not-required";

      if (shouldTriggerValidation()) {
        actionkit.forms.validate();
      }

      consentsElement.hidden = true;
    } else if (lastChosenCountryWasGermanic) {
      lastChosenCountryWasGermanic = false;
      optInInput.value = "1";
      consentActionInput.value = "n";
      radioButtonOptionYes.checked = false;
      radioButtonOptionNo.checked = false;
      consentsElement.hidden = false;
      consentInlineRequiredHidden.name = "required";
    }
  };

  const updateHiddenValueOnRadioChange = () => {
    const radioButtons = [
      ...document.querySelectorAll("[data-wm-consent-inline-radio]"),
    ];

    radioButtons.forEach((radio) => {
      radio.addEventListener("change", (event) => {
        const consentActionInput = document.querySelector(
          "[data-wm-consent-hidden-consent-action]"
        );
        consentActionInput.value = event.target.value;

        const hiddenInput = document.querySelector(
          "[data-wm-consent-hidden-optin]"
        );
        hiddenInput.value = event.target.value === "y" ? "" : "1";
      });
    });
  };

  const attachCountrySelectionEvent = () => {
    if (!countrySelect) {
      return;
    }

    countrySelect.addEventListener("change", setConsentStatusByCountry);
  };

  const initConsentsInline = () => {
    if (shouldWeOfferSubscription()) {
      attachCountrySelectionEvent();
      updateHiddenValueOnRadioChange();
      setConsentStatusByCountry();
    } else {
      setupKnownUserDOM();
    }

    window.wemove.triggerEvent("wm-optinReady");
  };

  initConsentsInline();
};
